import React from 'react'

function ReducedMotionBanner() {
  return (
    <div className='text-center text-2xl bg-stronghold-onyx p-4'>
        <span className='text-stronghold-platinum'>You are currently viewing the site with <strong>reduced motion</strong> enabled</span>
    </div>
  )
}

export default ReducedMotionBanner
